/* el-timeline.js — sections/el-timeline.liquid
   Desktop: the stages work as an accordion, one open at a time (clicking the
   open stage closes it). Mobile: every stage is shown open, nothing toggles. */
(function () {
  'use strict';

  if (window.elTimelineReady) return;
  window.elTimelineReady = true;

  var desktop = window.matchMedia('(min-width: 1024px)');

  function setOpen(stage, open) {
    var toggle = stage.querySelector('[data-el-stage-toggle]');
    var panel = stage.querySelector('.el-timeline__panel');
    stage.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  /* Smooth version: the stage slides open / shut (el-accordion-motion.js) */
  function slide(stage, open) {
    if (!window.elToggleHeight) { setOpen(stage, open); return; }
    window.elToggleHeight(stage, stage.querySelector('.el-timeline__panel'), function (o) { setOpen(stage, o); }, open);
  }

  /* Mobile shows everything; desktop goes back to the stage marked open */
  function sync(section) {
    section.querySelectorAll('[data-el-stage]').forEach(function (stage) {
      var toggle = stage.querySelector('[data-el-stage-toggle]');
      if (desktop.matches) {
        if (toggle) toggle.removeAttribute('tabindex');
        setOpen(stage, stage.classList.contains('is-open'));
      } else {
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          toggle.setAttribute('tabindex', '-1');
        }
        var panel = stage.querySelector('.el-timeline__panel');
        if (panel) panel.hidden = false;
      }
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-el-timeline]').forEach(sync);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-el-stage-toggle]');
    if (!toggle || !desktop.matches) return;
    var stage = toggle.closest('[data-el-stage]');
    var section = toggle.closest('[data-el-timeline]');
    if (!stage || !section) return;
    var willOpen = !stage.classList.contains('is-open');
    section.querySelectorAll('[data-el-stage].is-open').forEach(function (s) { if (s !== stage) slide(s, false); });
    slide(stage, willOpen);
  });

  /* Theme editor: open the stage being edited */
  document.addEventListener('shopify:block:select', function (event) {
    var stage = event.target.querySelector && event.target.querySelector('[data-el-stage]');
    var section = stage && stage.closest('[data-el-timeline]');
    if (!section || !desktop.matches) return;
    section.querySelectorAll('[data-el-stage].is-open').forEach(function (s) { if (s !== stage) setOpen(s, false); });
    setOpen(stage, true);
  });

  document.addEventListener('shopify:section:load', syncAll);
  if (desktop.addEventListener) desktop.addEventListener('change', syncAll);
  else desktop.addListener(syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
